import { render, staticRenderFns } from "./OrderContainer.vue?vue&type=template&id=53dce5bd&scoped=true&"
import script from "./OrderContainer.vue?vue&type=script&lang=js&"
export * from "./OrderContainer.vue?vue&type=script&lang=js&"
import style0 from "./OrderContainer.vue?vue&type=style&index=0&id=53dce5bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dce5bd",
  null
  
)

export default component.exports